export const TRUSTEDSHOP_IDS: Record<string, string> = {
  0: 'XFAB7C17C298F48909E8C9F2BFAA5794B',
  16: 'X976DB21C8D07D59CD7017A2F61F47052',
  17: 'X3DE729F568C455BB31536436C1CD5BB2',
  18: 'XCAF5333B6ABFCD1FB527F09ABA1326E3',
  24: 'XACDD419ACF96CC1BF2194F0CCE8F5643',
  37: 'XAFDFD06B3AA99CE8D1FCE3C6F18E8DB7',
  47: 'X22FC00EFDF64953A220BA4CEFE93211B',
  123: 'XACDD419ACF96CC1BF2194F0CCE8F5643',
  135: 'X22FC00EFDF64953A220BA4CEFE93211B',
};
